import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Customer, CustomerListResponse } from '@shared/models/customer.model';

export interface CustomerQuery {
  q?: string;          // 검색어 (code/name/email 등)
  enabled?: boolean;   // 활성/비활성 필터
  limit?: number;      // [New] Dropdown용 limit
}

export interface CreateCustomerDto {
  code: string;
  name: string;
  email?: string;
  phone?: string;
  memo?: string;
  assignedUsers?: string[];
  enabled?: boolean;
}

export interface UpdateCustomerDto extends Partial<CreateCustomerDto> { }

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private baseUrl = `${environment.api.baseUrl}/customer`;

  constructor(private http: HttpClient) { }

  list(query: CustomerQuery = {}): Observable<CustomerListResponse> {
    let params = new HttpParams();

    if (query.q) {
      params = params.set('q', query.q);
    }
    if (typeof query.enabled === 'boolean') {
      params = params.set('enabled', String(query.enabled));
    }
    if (query.limit) {
      params = params.set('limit', String(query.limit));
    }

    return this.http.get<CustomerListResponse>(this.baseUrl, { params });
  }

  getById(id: string): Observable<Customer> {
    return this.http.get<Customer>(`${this.baseUrl}/${id}`);
  }

  create(dto: CreateCustomerDto): Observable<Customer> {
    return this.http.post<Customer>(this.baseUrl, dto);
  }

  update(id: string, dto: UpdateCustomerDto): Observable<Customer> {
    return this.http.patch<Customer>(`${this.baseUrl}/${id}`, dto);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  updateEnabled(id: string, enabled: boolean): Observable<Customer> {
    return this.http.patch<Customer>(`${this.baseUrl}/${id}/enabled`, { enabled });
  }
}
